export default class AdherentPrefill {
    constructor(el) {
        this.form   = el;
        this.btn    = document.querySelector('#hwc-load-adherent-data');
        this.status = document.querySelector('#hwc-load-status');

        if (!this.btn) return;

        this.init();
    }

    init() {
        this.btn.addEventListener('click', () => this.load());
    }

    load() {
        const adh_number     = this.form.querySelector('[name="wpforms[fields][94]"]')?.value.trim();
        const raison_sociale = this.form.querySelector('[name="wpforms[fields][96]"]')?.value.trim();

        if (!adh_number || !raison_sociale) {
            this.setStatus('Veuillez renseigner le n° adhérent et la raison sociale.', 'red');
            return;
        }

        this.btn.disabled = true;
        this.btn.textContent = 'Chargement...';
        this.setStatus('', '');
        console.log('load');
        

        jQuery.ajax({
            url:  hwc_vars.ajax_url,
            type: 'post',
            data: {
                action:         'hwc_load_adherent_prefill',
                adh_number:     adh_number,
                raison_sociale: raison_sociale,
            },
            success: (response) => {
                if (!response.success) {
                    this.setStatus(response.data.message, 'red');
                    this.resetBtn();
                    return;
                }
                this.fill(response.data);
                this.setStatus('Informations chargées avec succès.', 'green');
                this.resetBtn();
            },
            error: () => {
                this.setStatus('Erreur réseau, veuillez réessayer.', 'red');
                this.resetBtn();
            },
        });
    }

    fill(d) {
        this.form.querySelectorAll('.hide-before-ajax').forEach(el => el.classList.remove('hide-before-ajax'));

        // Représentant (user)
        this.setVal('[name="wpforms[fields][100]"]',       d.user.function);
        this.setVal('[name="wpforms[fields][101]"]',       d.user.tel);
        this.setVal('[name="wpforms[fields][102][first]"]', d.user.first_name);
        this.setVal('[name="wpforms[fields][102][last]"]',  d.user.last_name);

        // Infos CPT adhérent
        this.setVal('[name="wpforms[fields][106]"]', d.web_site);
        this.setVal('[name="wpforms[fields][107]"]', d.mail);
        this.setVal('[name="wpforms[fields][115]"]', d.desc);

        // Adresse principale
        this.setVal('[name="wpforms[fields][108]"]', d.address);
        this.setVal('[name="wpforms[fields][109]"]', d.address_postcode);
        this.setVal('[name="wpforms[fields][110]"]', d.address_city);
        this.setVal('[name="wpforms[fields][119]"]', d.lat);
        this.setVal('[name="wpforms[fields][120]"]', d.lng);

        // Adresse de facturation (si différente)
        if (d.factu_diff) {
            const checkbox = this.form.querySelector('[name="wpforms[fields][117][]"][value="Adresse différente"]');
            if (checkbox) {
                checkbox.checked = true;
                checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
            this.setVal('[name="wpforms[fields][112]"]', d.address_factu.address);
            this.setVal('[name="wpforms[fields][113]"]', d.address_factu.address_postcode);
            this.setVal('[name="wpforms[fields][114]"]', d.address_factu.address_city);
        }
    }

    setVal(selector, value) {
        const el = this.form.querySelector(selector);
        if (el) el.value = value ?? '';
    }

    setStatus(msg, color) {
        if (!this.status) return;
        this.status.textContent = msg;
        this.status.style.color = color;
    }

    resetBtn() {
        this.btn.disabled = false;
        this.btn.textContent = 'Charger mes informations';
    }
}
